export const filterNonNull = (array) => {
    return array.filter((x) => x !== null);
  };